module.exports = __webpack_public_path__ + "static/media/rhe78g.95d29809.jpg";